import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiMenu, FiUser } from 'react-icons/fi';

const Header = ({ title, onOpenMenu }) => {
  const { user } = useAuth();

  // Helper function to create a simple avatar with the user's initials
  const getInitials = (name = '') => {
    const names = name.split(' ');
    // Handle cases with more than one name part
    if (names.length > 1) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    // Handle single-word names
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <header className="bg-white shadow-sm p-4 flex justify-between items-center gap-3 sticky top-0 z-10">
      <button type="button" onClick={onOpenMenu} aria-label="Open navigation" className="md:hidden flex min-h-11 min-w-11 items-center justify-center rounded-md text-gray-700 hover:bg-gray-100">
        <FiMenu size={24} />
      </button>
      {/* Page Title */}
      <h1 className="min-w-0 flex-1 truncate text-lg sm:text-2xl font-bold text-gray-800">{title}</h1>

      {/* User Profile Display */}
      <div className="flex shrink-0 items-center">
        <div className="hidden max-w-32 text-right mr-4 sm:block lg:max-w-48">
          <p className="truncate font-semibold text-gray-800">{user?.name}</p>
          {/* Safely map over roles, which is an array of objects */}
          <p className="truncate text-xs text-gray-500">{user?.roles?.map(r => r.name).join(', ')}</p>
        </div>
        <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm">
          {user ? getInitials(user.name) : <FiUser />}
        </div>
      </div>
    </header>
  );
};

export default Header;
